import { Document } from './document';

// Modelo principal para etapas (stages)
export interface Stages {
  id: number;
  name: string;
  sequence?: number; // orden
  probability?: number; // probabilidad %
  isActive?: boolean;
  isGlobal?: boolean;
  useForLeads?: boolean;
  teamIds?: number[];
  teams?: Array<{ id: number; name?: string }>;
  comment?: string;
  requiresActivity?: boolean;
  isFolded?: boolean;
  canCreateQuote?: boolean;
  completed?: boolean;
  odooEntityId?: number;
}

// Para crear (sin id requerido)
export type StagesCreate = Omit<Stages, 'id'>;

// Para actualizar (id obligatorio, resto opcional)
export type StagesUpdate = Partial<Stages> & { id: number };

// Tipo de Stage (catálogo)
export interface StagesType {
  id: number;
  name: string;
  isActive: boolean;
}

